import React from "react";

const css = `
  .qs-root {
    font-family: 'new-science', 'DM Sans', sans-serif;
    max-width: 860px;
    margin: 0 auto;
    padding: 32px 24px 64px;
    color: #0f172a;
  }
  .qs-hero { margin-bottom: 40px; padding-bottom: 28px; border-bottom: 1px solid #e2e8f0; }
  .qs-hero-eyebrow { font-size: 12px; font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase; color: #2563eb; margin-bottom: 8px; }
  .qs-hero-title { font-size: 28px; font-weight: 800; color: #0f172a; margin: 0 0 10px; letter-spacing: -0.5px; }
  .qs-hero-sub { font-size: 15px; color: #64748b; max-width: 620px; line-height: 1.6; margin: 0; }
  .qs-toc { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px; padding: 18px 20px; margin-bottom: 36px; }
  .qs-toc-title { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.07em; color: #94a3b8; margin: 0 0 10px; }
  .qs-toc-links { display: flex; flex-wrap: wrap; gap: 6px 20px; list-style: none; padding: 0; margin: 0; }
  .qs-toc-links a { font-size: 13.5px; color: #2563eb; text-decoration: none; font-weight: 500; }
  .qs-toc-links a:hover { text-decoration: underline; }
  .qs-section { margin-bottom: 40px; }
  .qs-section-header { display: flex; align-items: center; gap: 10px; margin-bottom: 16px; }
  .qs-section-icon { width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 15px; flex-shrink: 0; }
  .qs-section-title { font-size: 17px; font-weight: 700; color: #0f172a; margin: 0; }
  .qs-section-body { font-size: 14px; color: #475569; line-height: 1.7; }
  .qs-card { background: white; border: 1px solid #e2e8f0; border-radius: 10px; padding: 18px 20px; margin-bottom: 10px; transition: box-shadow 0.15s; }
  .qs-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.06); }
  .qs-card-title { font-size: 13.5px; font-weight: 600; color: #0f172a; margin: 0 0 5px; }
  .qs-card-body { font-size: 13px; color: #64748b; line-height: 1.6; margin: 0; }
  .qs-card-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 10px; }
  .qs-steps { display: flex; flex-direction: column; gap: 10px; }
  .qs-step { display: flex; gap: 14px; align-items: flex-start; background: white; border: 1px solid #e2e8f0; border-radius: 10px; padding: 14px 18px; }
  .qs-step-num { width: 26px; height: 26px; border-radius: 50%; background: #2563eb; color: white; font-size: 12px; font-weight: 700; display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin-top: 1px; }
  .qs-step-text { font-size: 13.5px; color: #0f172a; line-height: 1.5; }
  .qs-step-sub { font-size: 12.5px; color: #64748b; margin-top: 2px; }
  .qs-tip { background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 10px; padding: 14px 18px; margin-top: 14px; display: flex; gap: 10px; align-items: flex-start; }
  .qs-tip-icon { font-size: 15px; flex-shrink: 0; margin-top: 1px; }
  .qs-tip-text { font-size: 13px; color: #1e40af; line-height: 1.6; }
  .qs-tip-label { font-weight: 700; margin-right: 4px; }
  .qs-metric-row { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; }
  .qs-metric-badge { display: flex; align-items: center; gap: 7px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 8px 13px; font-size: 13px; color: #0f172a; font-weight: 500; }
  .qs-metric-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
  .qs-divider { border: none; border-top: 1px solid #e2e8f0; margin: 36px 0; }
`;

const SECTIONS = [
  { id: "plattform", label: "Die Plattform" },
  { id: "start", label: "Erste Schritte" },
  { id: "begriffe", label: "Begriffe & Konzepte" },
  { id: "metriken", label: "Metriken" },
  { id: "dashboard", label: "Brand Dashboard" },
  { id: "suchbegriffe", label: "Suchbegriffe" },
  { id: "topics", label: "Topics" },
  { id: "mitbewerber", label: "Mitbewerber" },
  { id: "sentiment", label: "Sentiment" },
  { id: "zitierungen", label: "Zitierungen" },
  { id: "credits", label: "Credits" },
];

export default function QuickStartGuide() {
  return (
    <div className="qs-root">
      <style>{css}</style>

      <div className="qs-hero">
        <div className="qs-hero-eyebrow">Loslegen</div>
        <h1 className="qs-hero-title">Quick Start Guide</h1>
        <p className="qs-hero-sub">
          Alles was du wissen musst, um deine Marke in AI-Suchergebnissen zu tracken —
          von der Einrichtung bis zur Auswertung der ersten Daten.
        </p>
      </div>

      <div className="qs-toc">
        <div className="qs-toc-title">Inhalt</div>
        <ul className="qs-toc-links">
          {SECTIONS.map(s => <li key={s.id}><a href={`#${s.id}`}>{s.label}</a></li>)}
        </ul>
      </div>

      {/* 1 */}
      <div className="qs-section" id="plattform">
        <div className="qs-section-header">
          <div className="qs-section-icon" style={{background:"#eff6ff"}}>🔭</div>
          <h2 className="qs-section-title">Die Plattform</h2>
        </div>
        <p className="qs-section-body">
          Unsere Plattform ermöglicht es dir, zu verfolgen, wie deine Marke in AI-generierten
          Suchergebnissen erscheint — in Modellen wie Google Gemini, ChatGPT, Perplexity, Claude und Copilot.
          Du kannst überwachen, wie oft deine Marke erwähnt wird, wie prominent sie platziert ist,
          und wie sie im Vergleich zu Mitbewerbern wahrgenommen wird.
        </p>
      </div>
      <hr className="qs-divider" />

      {/* 2 */}
      <div className="qs-section" id="start">
        <div className="qs-section-header">
          <div className="qs-section-icon" style={{background:"#f0fdf4"}}>🚀</div>
          <h2 className="qs-section-title">Erste Schritte</h2>
        </div>
        <div className="qs-steps">
          {[
            ["Brand-Setup-Wizard starten", "Marke anlegen und Domain hinzufügen"],
            ["Topics erstellen", "Relevante Themenbereiche für deine Marke definieren"],
            ["Suchbegriffe hinzufügen & AI-Engines auswählen", "Fragen und Prompts erfassen, die du tracken möchtest"],
            ["Tracking-Intervall konfigurieren", "Täglich, wöchentlich, monatlich oder manuell"],
            ["Performance beobachten & Mitbewerber analysieren", "Sichtbarkeit, Sentiment und Positionierung im Zeitverlauf verfolgen"],
          ].map(([text, sub], i) => (
            <div className="qs-step" key={i}>
              <div className="qs-step-num">{i+1}</div>
              <div>
                <div className="qs-step-text">{text}</div>
                <div className="qs-step-sub">{sub}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="qs-tip">
          <span className="qs-tip-icon">💡</span>
          <span className="qs-tip-text">
            <span className="qs-tip-label">Tipp:</span>
            Starte mit 3–5 zentralen Suchbegriffen pro Topic. So erhältst du schnell aussagekräftige Daten, ohne unnötig Credits zu verbrauchen.
          </span>
        </div>
      </div>
      <hr className="qs-divider" />

      {/* 3 */}
      <div className="qs-section" id="begriffe">
        <div className="qs-section-header">
          <div className="qs-section-icon" style={{background:"#fefce8"}}>📖</div>
          <h2 className="qs-section-title">Begriffe & Konzepte</h2>
        </div>
        <div className="qs-card-grid">
          {[
            ["Marke", "Der Name der Marke, die du verfolgst. Du kannst mehrere Schreibweisen hinterlegen."],
            ["Topic", "Eine Gruppe verwandter Suchbegriffe zur besseren Organisation deines Trackings."],
            ["Region", "Der Standort, von dem aus die AI-Suche ausgeführt wird. Lokalisierung wird für Google AI Overviews und ChatGPT unterstützt."],
            ["Suchbegriff", "Die Frage oder der Prompt, den du über AI-Suchmaschinen hinweg tracken möchtest."],
            ["AI Engine", "Das getrackte Modell – z. B. Google Gemini 2.0, Perplexity, ChatGPT, Claude, Copilot."],
            ["Run", "Eine einzelne Ausführung der Suchbegriff-Analyse über ausgewählte AI-Engines."],
            ["Intervall", "Wie häufig ein Suchbegriff automatisch aktualisiert wird (stündlich, täglich, wöchentlich, monatlich)."],
          ].map(([term, desc]) => (
            <div className="qs-card" key={term}>
              <div className="qs-card-title">{term}</div>
              <p className="qs-card-body">{desc}</p>
            </div>
          ))}
        </div>
      </div>
      <hr className="qs-divider" />

      {/* 4 */}
      <div className="qs-section" id="metriken">
        <div className="qs-section-header">
          <div className="qs-section-icon" style={{background:"#fdf4ff"}}>📊</div>
          <h2 className="qs-section-title">Metriken</h2>
        </div>
        <p className="qs-section-body" style={{marginBottom:14}}>
          Jeder getrackte Suchbegriff liefert eine vollständige Aufschlüsselung der AI-generierten Ergebnisse:
        </p>
        <div className="qs-metric-row">
          {[["Sichtbarkeit","#2563eb"],["Position / Rang","#7c3aed"],["Sentiment","#16a34a"],["Erwähnungen","#ea580c"],["Erkennungsrate","#0891b2"],["Zitierungen","#d97706"],["Top-3-Sichtbarkeit","#dc2626"]].map(([label,color]) => (
            <div className="qs-metric-badge" key={label}>
              <div className="qs-metric-dot" style={{background:color}} />{label}
            </div>
          ))}
        </div>
        <div className="qs-card-grid" style={{marginTop:14}}>
          {[
            ["Sichtbarkeit", "Wie oft und wie prominent deine Marke in AI-Suchergebnissen erscheint."],
            ["Position / Rang", "Wo deine Marke im AI-generierten Inhalt erwähnt wird (1 = erste Position)."],
            ["Sentiment", "Gibt an, wie positiv oder negativ deine Marke von der AI-Engine beschrieben wird."],
            ["Erkennungsrate", "Wie oft deine Marke erkannt wurde. Verfügbar pro Suchbegriff und im Brand Dashboard."],
            ["Zitierungen", "Anzahl der Verlinkungen oder Referenzen auf deine Marke in den AI-Antworten."],
            ["Top-3-Sichtbarkeit", "Der Prozentsatz der Ergebnisse, in denen deine Marke unter den Top 3 war."],
          ].map(([term, desc]) => (
            <div className="qs-card" key={term}>
              <div className="qs-card-title">{term}</div>
              <p className="qs-card-body">{desc}</p>
            </div>
          ))}
        </div>
      </div>
      <hr className="qs-divider" />

      {/* 5 */}
      <div className="qs-section" id="dashboard">
        <div className="qs-section-header">
          <div className="qs-section-icon" style={{background:"#f0fdf4"}}>📈</div>
          <h2 className="qs-section-title">Brand Dashboard</h2>
        </div>
        <p className="qs-section-body">
          Das Brand Dashboard gibt dir einen Überblick über die Performance deiner Marke über alle getrackten AI-Suchergebnisse, Topics und Engines hinweg.
        </p>
        <div className="qs-card-grid" style={{marginTop:14}}>
          {[
            ["Performance-Karten", "Zeigen Sichtbarkeit, Sentiment, Erwähnungen, Zitierungen, Durchschnittsposition, Erkennungsrate und Top-3-Sichtbarkeit auf einen Blick."],
            ["Performance im Zeitverlauf", "Verfolgt Sichtbarkeits-Trends über alle Marken hinweg. Jede Linie repräsentiert eine andere Marke."],
            ["Topic-Performance", "Zeigt, wie deine Marke über verschiedene Topics abschneidet – welche Bereiche die meiste Sichtbarkeit erzeugen."],
            ["AI Engine Performance", "Zeigt, wie deine Marke auf den verschiedenen AI-Engines performt und wo Verbesserungspotenzial besteht."],
          ].map(([term, desc]) => (
            <div className="qs-card" key={term}>
              <div className="qs-card-title">{term}</div>
              <p className="qs-card-body">{desc}</p>
            </div>
          ))}
        </div>
        <div className="qs-tip">
          <span className="qs-tip-icon">💡</span>
          <span className="qs-tip-text">
            <span className="qs-tip-label">Tipp:</span>
            Klicke unter dem Performance-Diagramm auf «Datentabelle anzeigen» für eine detaillierte Aufschlüsselung der Rohdaten.
          </span>
        </div>
      </div>
      <hr className="qs-divider" />

      {/* 6 */}
      <div className="qs-section" id="suchbegriffe">
        <div className="qs-section-header">
          <div className="qs-section-icon" style={{background:"#fff7ed"}}>🔍</div>
          <h2 className="qs-section-title">Suchbegriffe</h2>
        </div>
        <p className="qs-section-body">
          Suchbegriffe sind das Herzstück deines Brand-Trackings — jeder Begriff steht für eine Frage oder einen Prompt, den du über AI-Suchmaschinen hinweg verfolgst.
        </p>
        <div className="qs-card-grid" style={{marginTop:14}}>
          {[
            ["Manuell hinzufügen", "Direkte Eingabe einzelner Suchbegriffe im Suchbegriffe-Bereich."],
            ["Bulk-Import", "Mehrere Suchbegriffe auf einmal über eine Liste importieren."],
            ["Mit AI generieren", "Lass die Plattform passende Suchbegriffe für deine Marke und dein Topic vorschlagen."],
          ].map(([term, desc]) => (
            <div className="qs-card" key={term}>
              <div className="qs-card-title">{term}</div>
              <p className="qs-card-body">{desc}</p>
            </div>
          ))}
        </div>
        <div className="qs-tip">
          <span className="qs-tip-icon">💡</span>
          <span className="qs-tip-text">
            <span className="qs-tip-label">Tipp:</span>
            Credits und verbleibende Laufzeit («Runway») werden im Suchbegriffe-Bereich sowie in der Seitenleiste angezeigt.
          </span>
        </div>
      </div>
      <hr className="qs-divider" />

      {/* 7 */}
      <div className="qs-section" id="topics">
        <div className="qs-section-header">
          <div className="qs-section-icon" style={{background:"#f0fdf4"}}>🗂️</div>
          <h2 className="qs-section-title">Topics</h2>
        </div>
        <p className="qs-section-body">
          Topics ermöglichen es dir, verwandte Suchbegriffe in sinnvolle Gruppen zu organisieren. Statt einzelne Begriffe separat zu verwalten, kannst du sie in thematische Cluster einteilen.
        </p>
        <div className="qs-card" style={{marginTop:14}}>
          <div className="qs-card-title">Beispiel-Topics</div>
          <p className="qs-card-body">
            «Produktfunktionen» – alle Suchbegriffe rund um deine Produkteigenschaften<br/>
            «Mitbewerbervergleiche» – Begriffe, die deine Marke anderen gegenüberstellen<br/>
            «Kundenservice» – Fragen zu Support, Erreichbarkeit und Zufriedenheit
          </p>
        </div>
        <div className="qs-tip">
          <span className="qs-tip-icon">💡</span>
          <span className="qs-tip-text">
            <span className="qs-tip-label">Best Practices:</span>
            Halte Topic-Namen kurz und aussagekräftig · Plane 3–10 Suchbegriffe pro Topic ein · Überprüfe Topics vierteljährlich · Orientiere dich am Marketing-Funnel.
          </span>
        </div>
      </div>
      <hr className="qs-divider" />

      {/* 8 */}
      <div className="qs-section" id="mitbewerber">
        <div className="qs-section-header">
          <div className="qs-section-icon" style={{background:"#fef2f2"}}>⚔️</div>
          <h2 className="qs-section-title">Mitbewerber-Tracking</h2>
        </div>
        <p className="qs-section-body">
          Mitbewerber werden automatisch erkannt — du musst sie nicht manuell erfassen. Die Plattform identifiziert Marken, die in AI-Antworten zusammen mit deiner Marke auftauchen.
        </p>
        <div className="qs-card-grid" style={{marginTop:14}}>
          {[
            ["Position", "Durchschnittliche Position des Mitbewerbers in den Suchergebnissen."],
            ["Top-3-Sichtbarkeit", "Wie oft der Mitbewerber in den Top 3 der Ergebnisse erscheint."],
            ["Sentiment", "Wie positiv oder negativ der Mitbewerber von AI-Engines beschrieben wird."],
            ["Erkennungsrate", "In wie vielen Runs der Mitbewerber gefunden wurde."],
            ["Trend", "Ob die Sichtbarkeit des Mitbewerbers steigt, stagniert oder fällt."],
          ].map(([term, desc]) => (
            <div className="qs-card" key={term}>
              <div className="qs-card-title">{term}</div>
              <p className="qs-card-body">{desc}</p>
            </div>
          ))}
        </div>
        <div className="qs-tip">
          <span className="qs-tip-icon">💡</span>
          <span className="qs-tip-text">
            <span className="qs-tip-label">Tipp:</span>
            Nutze Trenddaten über einen längeren Zeitraum für die verlässlichsten Erkenntnisse — Mitbewerber-Daten können je nach AI-Engine und Suchformulierung variieren.
          </span>
        </div>
      </div>
      <hr className="qs-divider" />

      {/* 9 */}
      <div className="qs-section" id="sentiment">
        <div className="qs-section-header">
          <div className="qs-section-icon" style={{background:"#f0fdf4"}}>😊</div>
          <h2 className="qs-section-title">Sentiment-Analyse</h2>
        </div>
        <p className="qs-section-body">
          Die Sentiment-Analyse misst, wie AI-Suchmaschinen deine Marke beschreiben. Jede Erwähnung wird auf positiven, neutralen oder negativen Charakter geprüft.
        </p>
        <div className="qs-card-grid" style={{marginTop:14}}>
          {[
            ["😊 Positiv", "Die AI-Engine beschreibt deine Marke vorteilhaft – z. B. «führende Lösung», «hoch bewertet», «erste Wahl».", "#16a34a"],
            ["😐 Neutral", "Die AI-Engine erwähnt deine Marke sachlich, ohne stark positive oder negative Sprache.", "#64748b"],
            ["😟 Negativ", "Die AI-Engine beschreibt deine Marke ungünstig – z. B. «eingeschränkte Funktionen», «schlechter Support».", "#dc2626"],
          ].map(([term, desc, color]) => (
            <div className="qs-card" key={term} style={{borderLeft:`3px solid ${color}`}}>
              <div className="qs-card-title">{term}</div>
              <p className="qs-card-body">{desc}</p>
            </div>
          ))}
        </div>
        <div className="qs-tip">
          <span className="qs-tip-icon">💡</span>
          <span className="qs-tip-text">
            <span className="qs-tip-label">Tipp:</span>
            Verknüpfe Sentiment-Veränderungen mit Marketingkampagnen oder Produktlaunches um deren Wirkung zu messen. Verschiedene AI-Engines können deine Marke unterschiedlich wahrnehmen.
          </span>
        </div>
      </div>
      <hr className="qs-divider" />

      {/* 10 */}
      <div className="qs-section" id="zitierungen">
        <div className="qs-section-header">
          <div className="qs-section-icon" style={{background:"#fefce8"}}>🔗</div>
          <h2 className="qs-section-title">Zitierungen</h2>
        </div>
        <p className="qs-section-body">
          Zitierungen sind Domains, URLs und Quellen, auf die AI-Engines in ihren Antworten verweisen. Wenn AI-Engines deine Inhalte zitieren, gilt dein Content als vertrauenswürdig.
        </p>
        <div className="qs-card-grid" style={{marginTop:14}}>
          {[
            ["Autorität", "Zitierungen signalisieren, dass dein Content als massgebend gilt."],
            ["Traffic-Potenzial", "Zitierungen können Referral-Traffic erzeugen, wenn Nutzer auf die Quellen klicken."],
            ["Mitbewerber-Analyse", "Sieh, welche Mitbewerber-Domains am häufigsten zitiert werden."],
            ["Content-Strategie", "Erkenne welche Inhaltstypen zitiert werden und nutze das für deine Planung."],
          ].map(([term, desc]) => (
            <div className="qs-card" key={term}>
              <div className="qs-card-title">{term}</div>
              <p className="qs-card-body">{desc}</p>
            </div>
          ))}
        </div>
        <div className="qs-tip">
          <span className="qs-tip-icon">💡</span>
          <span className="qs-tip-text">
            <span className="qs-tip-label">Tipp:</span>
            Nutze Zitierungs-Trends zusammen mit Sichtbarkeits-Scores für ein vollständiges Bild deiner AI-Präsenz.
          </span>
        </div>
      </div>
      <hr className="qs-divider" />

      {/* 11 */}
      <div className="qs-section" id="credits">
        <div className="qs-section-header">
          <div className="qs-section-icon" style={{background:"#fff7ed"}}>⚡</div>
          <h2 className="qs-section-title">Credits</h2>
        </div>
        <p className="qs-section-body">
          Credits steuern dein Brand-Tracking. Jede Aktualisierung eines Suchbegriffs zählt als Run — und jeder Run verbraucht Credits, abhängig von der verwendeten AI-Engine.
        </p>
        <div className="qs-card-grid" style={{marginTop:14}}>
          {[
            ["Was ist ein Run?", "Eine Ausführung eines Suchbegriffs gegen eine oder mehrere AI-Engines. Jede Aktualisierung – manuell oder geplant – zählt als ein Run pro Engine."],
            ["Beispiel", "1 Suchbegriff · 3 AI-Engines · 1 Aktualisierung = 3 Runs."],
            ["Runway", "Zeigt dir, wie viele Tage automatische Updates noch verfügbar sind – basierend auf deinen aktuellen Einstellungen und verbleibenden Credits."],
          ].map(([term, desc]) => (
            <div className="qs-card" key={term}>
              <div className="qs-card-title">{term}</div>
              <p className="qs-card-body">{desc}</p>
            </div>
          ))}
        </div>
        <div className="qs-tip">
          <span className="qs-tip-icon">💡</span>
          <span className="qs-tip-text">
            <span className="qs-tip-label">Tipp:</span>
            Führe wichtige Suchbegriffe täglich aus, sekundäre Begriffe wöchentlich oder manuell — so nutzt du deine Credits effizient. Dein Guthaben siehst du im Bereich «Suchbegriffe» oder in der Seitenleiste.
          </span>
        </div>
      </div>

    </div>
  );
}